export type Purchase = {
  name: string
  city: string
  state: string
}

/** Sample buyers for the recent-purchase notifications. */
export const recentPurchases: Purchase[] = [
  { name: 'Ashley M.', city: 'Dallas', state: 'Texas' },
  { name: 'Brittany K.', city: 'Tampa', state: 'Florida' },
  { name: 'Jessica R.', city: 'Columbus', state: 'Ohio' },
  { name: 'Megan T.', city: 'Charlotte', state: 'North Carolina' },
  { name: 'Danielle P.', city: 'Phoenix', state: 'Arizona' },
  { name: 'Courtney S.', city: 'Nashville', state: 'Tennessee' },
  { name: 'Lauren B.', city: 'Atlanta', state: 'Georgia' },
  { name: 'Kayla W.', city: 'Sacramento', state: 'California' },
  { name: 'Amanda G.', city: 'Oklahoma City', state: 'Oklahoma' },
  { name: 'Rachel D.', city: 'Louisville', state: 'Kentucky' },
  { name: 'Tiffany H.', city: 'St. Louis', state: 'Missouri' },
  { name: 'Whitney L.', city: 'Birmingham', state: 'Alabama' },
]
